<sc-activity-list-item [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed">
    <i scActivityIcon class="fa-sharp fa-solid fa-trophy"></i>
    {{ texts.hiredPrefix[language] }} @if (context != 'candidate') { <strong>{{ activity.Candidate?.FirstName }} {{ activity.Candidate?.LastName }}</strong> } {{ texts.hiredSuffix[language] }}
</sc-activity-list-item>
